// Hamburger Menu JavaScript - 3 Panel System

 
(function() {
  'use strict';
   

  // Cache DOM elements
  let hamburgerMenu;
  let hamburgerTrigger;
  let hamburgerMobileTrigger;
  let hamburgerOverlay;
  let hamburgerClose;
  let hamburgerMobileClose;
  
  // Desktop panel elements
  let panel1, panel2, panel3;
  let panel2Content, panel3Content;
  let panel2Title, panel3Title;
  
  // Mobile panel elements
  let mobilePanel1, mobilePanel2, mobilePanel3;
  let mobilePanel2Content, mobilePanel3Content;
  let mobileBackButton; // legacy single ref
  let mobileBackButtons; // NodeList of all back buttons
  
  // Menu data
  let menuData = [];
  
  // Colored link settings
  let coloredLinkName = 'Sale';
  let coloredLinkColor = '#ff0000';
  
  // State management
  let isOpen = false;
  let currentPanel = 1;
  let currentMobilePanel = 1;
  let currentParent = null;
  let currentGrandParent = null; 

  // Initialize Flickity carousel for mobile promo images
  function initMobilePromoCarousel() {
    // Only initialize on mobile
    if (window.innerWidth <= 768) {
      const mobilePromoImages = document.getElementById('mobile-panel-1-promo-images');
      
      if (mobilePromoImages && typeof Flickity !== 'undefined') {
        // Destroy existing instance if it exists
        if (mobilePromoImages.flickity) {
          mobilePromoImages.flickity.destroy();
        }
        
        // Initialize new Flickity instance
        new Flickity(mobilePromoImages, {
          cellAlign: 'left',
          contain: true,
          draggable: true,
          pageDots: true,
          prevNextButtons: false,
          adaptiveHeight: false,
          wrapAround: false,
          freeScroll: true,
          cellSelector: '.promo-image-item'
        });
      }
    }
  }

  // Initialize
  function init() { 
    
    // Test if we can find any hamburger menu elements
    const allHamburgerElements = document.querySelectorAll('[class*="hamburger-menu"]');
 
    // Check if the hamburger menu container exists
    const hamburgerContainer = document.getElementById('HamburgerMenu');
 
    
    // Check if hamburger menu is enabled
    const tempTrigger = document.querySelector('.hamburger-menu-trigger');
   
    // Check if desktop version is being shown
    const desktopMenu = document.querySelector('.hamburger-menu-desktop');
 
    
    // Find DOM elements
    hamburgerMenu = document.getElementById('HamburgerMenu');
     hamburgerOverlay = document.querySelector('.hamburger-menu-overlay');
     
    // Find all trigger buttons
    const hamburgerTriggers = document.querySelectorAll('.hamburger-menu-trigger');
     
    // Use the first one found (should work for both desktop and mobile)
    hamburgerTrigger = hamburgerTriggers[0];
      
    // Find close buttons
    hamburgerClose = document.querySelector('.hamburger-menu-close');
    hamburgerMobileClose = document.querySelector('.hamburger-menu-mobile-close');
    
    // Find desktop panels
    panel1 = document.getElementById('panel-1');
    panel2 = document.getElementById('panel-2');
    panel3 = document.getElementById('panel-3');
    panel2Content = document.getElementById('panel-2-content');
    panel3Content = document.getElementById('panel-3-content');
    panel2Title = document.getElementById('panel-2-title');
    panel3Title = document.getElementById('panel-3-title');
     
    
    // Find mobile panels
    mobilePanel1 = document.getElementById('mobile-panel-1');
    mobilePanel2 = document.getElementById('mobile-panel-2');
    mobilePanel3 = document.getElementById('mobile-panel-3');
    mobilePanel2Content = document.getElementById('mobile-panel-2-content');
    mobilePanel3Content = document.getElementById('mobile-panel-3-content');
    mobileBackButton = document.querySelector('.hamburger-menu-mobile-back');
    mobileBackButtons = document.querySelectorAll('.hamburger-menu-mobile-back');
    
    // Load menu data
    loadMenuData();
    
    if (!hamburgerMenu) {
       return;
    }
    
    if (!hamburgerTrigger) {
       return;
    }
    
    bindEvents();
    

  }

  // Load menu data from JSON
  function loadMenuData() {
    const dataElement = document.getElementById('hamburger-menu-data');
    if (dataElement) {
      try {
        const data = JSON.parse(dataElement.textContent);
        menuData = data.menu || [];
        coloredLinkName = data.coloredLinkName || 'Sale';
        coloredLinkColor = data.coloredLinkColor || '#ff0000';
      } catch (error) {
        console.error('Error parsing menu data:', error);
        menuData = [];
        coloredLinkName = 'Sale';
        coloredLinkColor = '#ff0000';
      }
    }
  }

  function handleClickMenuLink(event) {
    Shopify.analytics.publish("navigation_click", {
      page_path: window.location.pathname,
      page_path_appended_query: window.location.pathname + window.location.search,
      page_url: window.location.href,
      navigation_selected: event.target.dataset.breadcrumbs,
    });
  }

  function bindMenuClickEvents() {
    const menuLinks = document.querySelectorAll('a.hamburger-menu-link, a.hamburger-menu-mobile-link, a.hamburger-menu-panel-item'); 
    menuLinks.forEach((link) => {
      link.addEventListener('click', handleClickMenuLink);
    });
  }

  // Bind event listeners
  function bindEvents() { 
    bindMenuClickEvents();
    
    // Bind events to all trigger buttons
    const hamburgerTriggers = document.querySelectorAll('.hamburger-menu-trigger'); 
    
    hamburgerTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', openMenu); 
    });
    
    // Close buttons
    if (hamburgerClose) {
      hamburgerClose.addEventListener('click', closeMenu);
    }
    if (hamburgerMobileClose) {
      hamburgerMobileClose.addEventListener('click', closeMenu);
    }
    
    // Clickable title resets to promo view (desktop + mobile)
    const menuTitle = document.querySelector('.hamburger-menu-title');
    if (menuTitle) {
      const resetToPromo = (e) => {
        e.preventDefault();
        // Desktop: ensure panel 3 is closed, then reset panel 2 to promo images
        resetPanel3();
        resetPanel2ToPromoView();
        // Mobile: show panel 1 with promo images above nav
        showMobilePanel2WithPromoImages();
      };
      menuTitle.addEventListener('click', resetToPromo);
      menuTitle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          resetToPromo(e);
        }
      });
    }

    // Mobile header title: go back to panel 1 (close 2/3)
    const mobileMenuTitle = document.querySelector('.hamburger-menu-mobile-title');
    if (mobileMenuTitle) {
      const goToMobilePanel1 = (e) => {
        e.preventDefault();
        // Ensure mobile returns to panel 1 regardless of current state
        currentMobilePanel = 1;
        if (mobilePanel2) mobilePanel2.style.display = 'none';
        if (mobilePanel3) mobilePanel3.style.display = 'none';
        if (mobilePanel1) mobilePanel1.style.display = 'block';
        // Hide back buttons
        const mobilePanel2BackButton = document.querySelector('#mobile-panel-2 .hamburger-menu-mobile-back');
        if (mobilePanel2BackButton) mobilePanel2BackButton.style.display = 'none';
        const mobilePanel3BackButton = document.querySelector('#mobile-panel-3 .hamburger-menu-mobile-back');
        if (mobilePanel3BackButton) mobilePanel3BackButton.style.display = 'none';
        // Clear mobile panel 2 content and titles; remove nav padding
        if (mobilePanel2Content) mobilePanel2Content.innerHTML = '';
        const mobilePanel2Title = document.getElementById('mobile-panel-2-title');
        if (mobilePanel2Title) mobilePanel2Title.textContent = '';
        const mobilePanel3Title = document.getElementById('mobile-panel-3-title');
        if (mobilePanel3Title) mobilePanel3Title.textContent = '';
        const mobilePanel = document.querySelector('#mobile-panel-2');
        if (mobilePanel) mobilePanel.classList.remove('has-navigation-content');
        // Ensure promo images are visible on panel 1
        const mobilePromoImages = document.getElementById('mobile-panel-1-promo-images');
        if (mobilePromoImages) mobilePromoImages.style.display = 'block';
      };
      mobileMenuTitle.addEventListener('click', goToMobilePanel1);
      mobileMenuTitle.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          goToMobilePanel1(e);
        }
      });
    }
    
    // Mobile back buttons (bind for both panel 2 and panel 3 headers)
    if (mobileBackButtons && mobileBackButtons.length) {
      mobileBackButtons.forEach((btn) => {
        btn.addEventListener('click', handleMobileBack);
      });
    } else if (mobileBackButton) {
      // Fallback for legacy single button
      mobileBackButton.addEventListener('click', handleMobileBack);
    }
    
    // Desktop panel navigation
    if (panel1) {
      panel1.addEventListener('click', handlePanel1Click);
    }
    if (panel2) {
      panel2.addEventListener('click', handlePanel2Click);
    }
    if (panel3) {
      panel3.addEventListener('click', handlePanel3Click);
    }
    
    // Mobile panel navigation
    if (mobilePanel1) {
      mobilePanel1.addEventListener('click', handleMobilePanel1Click);
    }
    
    // Overlay click to close
    if (hamburgerOverlay) {
      hamburgerOverlay.addEventListener('click', closeMenu);
    }
    
    // Keyboard events
    document.addEventListener('keydown', handleKeydown);
    
    // Resize handler for mobile carousel
    window.addEventListener('resize', handleResize);
  }

  // Handle panel 1 clicks (desktop)
  function handlePanel1Click(e) {
    const target = e.target.closest('.hamburger-menu-link--has-children');
    
    if (target) {
      e.preventDefault();
      const parentHandle = target.dataset.parent;
      const title = target.dataset.title;
       
      
      // Reset panel 3 if it's currently active
      resetPanel3();
      
      showPanel2(title, parentHandle);
    }
  }

  // Handle panel 2 clicks (desktop)
  function handlePanel2Click(e) {
    const target = e.target.closest('.hamburger-menu-panel-item--has-children');
    if (target) {
      e.preventDefault();
      const menuItem = target.dataset.menuItem;
      const title = target.querySelector('.hamburger-menu-panel-text').textContent;
      showPanel3(title, menuItem);
    }
  }

  // Handle panel 3 clicks (desktop)
  function handlePanel3Click(e) {
    // Panel 3 only shows direct links, no further navigation
  }

  // Handle mobile panel 1 clicks
  function handleMobilePanel1Click(e) {
    const target = e.target.closest('.hamburger-menu-mobile-link--has-children');
    if (target) {
      e.preventDefault();
      const parentHandle = target.dataset.parent;
      const title = target.dataset.title;
      
      // Reset mobile panel 3 if it's currently active
      resetMobilePanel3();
      
      showMobilePanel2(title, parentHandle);
    }
  }

  // Show panel 2 with promo images (default state)
  function showPanel2WithPromoImages() {
    resetPanel2ToPromoView();
  }

  // Show panel 2 (desktop)
  function showPanel2(title, parentHandle) {
    currentPanel = 2;
    currentParent = parentHandle;
     
    
          // Hide promo images when showing navigation content (but don't remove them)
      const promoImages = document.getElementById('panel-2-promo-images');
      if (promoImages) {
        promoImages.style.display = 'none';
       }
      
      // Add class to panel body to restore normal padding for navigation
      const panelBody = document.querySelector('.hamburger-menu-panel-2 .hamburger-menu-panel-body');
      if (panelBody) {
        panelBody.classList.add('has-navigation-content');
      }
      // Remove promo-image state on panel 2 when showing navigation
      if (panel2) {
        panel2.classList.remove('has-promo-image');
      }
    
    // Update title and show it
    if (panel2Title) {
      panel2Title.textContent = title;
      panel2Title.style.display = 'block';
    }
    
    // Load content
    loadPanel2Content(parentHandle);
    
    // Show panel using transforms
    if (panel2) {
      panel2.classList.add('is-active');
      // Reset panel 2 scroll to top
      const panel2Body = panel2.querySelector('.hamburger-menu-panel-body');
      if (panel2Body) {
        panel2Body.scrollTop = 0;
      }
     }  
  }

  // Show panel 3 (desktop)
  function showPanel3(title, menuItem) {
    currentPanel = 3;
    currentGrandParent = currentParent;
     
    
    // Update title and show it
    if (panel3Title) {
      panel3Title.textContent = title;
      panel3Title.style.display = 'block';
    }
    
      // Load content
  loadPanel3Content(menuItem);
  
  // Show panel using transforms
  if (panel3) {
    panel3.classList.add('is-active'); 
    // Reset panel 3 scroll to top
    const panel3Body = panel3.querySelector('.hamburger-menu-panel-body');
    if (panel3Body) {
      panel3Body.scrollTop = 0;
    }
  }  
}

  // Show mobile panel 2
  function showMobilePanel2(title, parentHandle) {
    currentMobilePanel = 2;
    currentParent = parentHandle;
    
    // Set the panel title
    const mobilePanel2Title = document.getElementById('mobile-panel-2-title');
    if (mobilePanel2Title) {
      mobilePanel2Title.textContent = title;
    }
    
    // Hide promo images when showing navigation content
    const mobilePromoImages = document.getElementById('mobile-panel-2-promo-images');
    if (mobilePromoImages) {
      mobilePromoImages.style.display = 'none';
    }
    
    // Add class to mobile panel body to restore normal padding for navigation
    const mobilePanelBody = document.querySelector('#mobile-panel-2');
    if (mobilePanelBody) {
      mobilePanelBody.classList.add('has-navigation-content');
    }
    
    // Load content
    loadMobilePanel2Content(parentHandle);
    
    // Hide panel 1, show panel 2
    if (mobilePanel1) mobilePanel1.style.display = 'none';
    if (mobilePanel2) mobilePanel2.style.display = 'block';
    // Reset mobile panel 2 scroll to top
    if (mobilePanel2) {
      mobilePanel2.scrollTop = 0;
    }
    
    // Show back button in panel 2 header
    const mobilePanel2BackButton = mobilePanel2?.querySelector('.hamburger-menu-mobile-back');
    if (mobilePanel2BackButton) {
      mobilePanel2BackButton.style.display = 'flex';
    }
  }

  // Show mobile panel 3
  function showMobilePanel3(title, menuItem) {
    currentMobilePanel = 3;
    currentGrandParent = currentParent;
    
    // Set the panel title
    const mobilePanel3Title = document.getElementById('mobile-panel-3-title');
    if (mobilePanel3Title) {
      mobilePanel3Title.textContent = title;
    }
    
    // Load content
    loadMobilePanel3Content(menuItem);
    
    // Hide panel 2, show panel 3
    if (mobilePanel2) mobilePanel2.style.display = 'none';
    if (mobilePanel3) mobilePanel3.style.display = 'block';
    // Reset mobile panel 3 scroll to top
    if (mobilePanel3) {
      mobilePanel3.scrollTop = 0;
    }
    
    // Show back button in panel 3 header
    const mobilePanel3BackButton = mobilePanel3?.querySelector('.hamburger-menu-mobile-back');
    if (mobilePanel3BackButton) {
      mobilePanel3BackButton.style.display = 'flex';
    }
  }

  // Show mobile panel 2 with promo images (default state)
  function showMobilePanel2WithPromoImages() {
    // Check if mobile promo images exist in panel 1
    const mobilePromoImages = document.getElementById('mobile-panel-1-promo-images');
    
    if (mobilePromoImages) {
      currentMobilePanel = 1;
      currentParent = null;
      
      // Stay on panel 1, promo images are already visible above navigation
      if (mobilePanel1) mobilePanel1.style.display = 'block';
      if (mobilePanel2) mobilePanel2.style.display = 'none';
      
      // Ensure promo images are visible
      mobilePromoImages.style.display = 'block';
      
    } else {
      // No promo images, stay on mobile panel 1
      currentMobilePanel = 1; 
    }
  }

  // Load panel 2 content
  function loadPanel2Content(parentHandle) {
    if (!panel2Content) {
      return;
    }
    
    const parent = menuData.find(item => item.handle === parentHandle);
    if (!parent || !parent.children) {
      return;
    }
    
    // Set the panel title
    const panel2Title = document.getElementById('panel-2-title');
    if (panel2Title) {
      panel2Title.textContent = parent.title;
    }
    
    // Separate full-width links (header) from image items (grid)
    const fullWidthLinks = parent.children.filter(child => 
      (child.children && child.children.length > 0) || child.isFullWidth
    );
    
    const imageItems = parent.children.filter(child => 
      !(child.children && child.children.length > 0) && !child.isFullWidth
    );
    
    // Create header section with full-width links
    const headerHtml = fullWidthLinks.map(child => {
      const isColoredLink = child.title.toLowerCase() === coloredLinkName.toLowerCase();
      const coloredLinkStyle = isColoredLink ? `style="color: ${coloredLinkColor};"` : '';
      
      if (child.children && child.children.length > 0) {
        // Has sub-children, show as button (full width)
        return `
          <button type="button" class="hamburger-menu-panel-item hamburger-menu-panel-item--has-children full-width-nav-link" 
                  data-menu-item="${child.handle}">
            <div class="hamburger-menu-panel-text" ${coloredLinkStyle}>
              ${child.title}
              <svg class="hamburger-menu-arrow" viewBox="0 0 100 100">
                <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
              </svg>
            </div>
          </button>
        `;
      } else {
        // Full width link (no image)
        return `
          <a href="${child.url}" data-breadcrumbs="${currentParent}:${child.handle}" class="hamburger-menu-panel-item full-width-nav-link">
            <div class="hamburger-menu-panel-text" ${coloredLinkStyle}>${child.title}</div>
          </a>
        `;
      }
    }).join('');
    
    // Create grid section with image items
    const gridHtml = imageItems.map(child => {
      const imageStyle = child.image ? `style="background-image: url('${child.image}');"` : '';
      return `
        <a href="${child.url}" data-breadcrumbs="${currentParent}:${child.handle}" class="hamburger-menu-panel-item">
          <div class="hamburger-menu-panel-image" ${imageStyle}></div>
          <div class="hamburger-menu-panel-text">${child.title}</div>
        </a>
      `;
    }).join('');
    
    // Render full-width links in the header, image items in the grid
    const panel2HeaderLinks = document.getElementById('panel-2-header-links');
    if (panel2HeaderLinks) {
      panel2HeaderLinks.innerHTML = headerHtml;
    }
    
    // Render image items in the grid
    panel2Content.innerHTML = gridHtml;
    bindMenuClickEvents();
  }

  // Load panel 3 content
  function loadPanel3Content(menuItem) {
    if (!panel3Content) return;
    
    const parent = menuData.find(item => item.handle === currentParent);
    if (!parent || !parent.children) return;
    
    const child = parent.children.find(c => c.handle === menuItem);
    if (!child || !child.children) return;
    
    // Set the panel title
    const panel3Title = document.getElementById('panel-3-title');
    if (panel3Title) {
      panel3Title.textContent = child.title;
    }
    
    const html = child.children.map(grandchild => {
      const imageStyle = grandchild.image ? `style="background-image: url('${grandchild.image}');"` : '';
      return `
        <a href="${grandchild.url}" data-breadcrumbs="${currentGrandParent}:${menuItem}:${grandchild.handle}" class="hamburger-menu-panel-item">
          <div class="hamburger-menu-panel-image" ${imageStyle}></div>
          <div class="hamburger-menu-panel-text">${grandchild.title}</div>
        </a>
      `;
    }).join('');
    
    // Render image items in the grid
    panel3Content.innerHTML = html;
    bindMenuClickEvents();
    
    // Match Panel 3 header height to Panel 2 header height
    const panel2Header = document.querySelector('.panel-2-header');
    const panel3Header = document.querySelector('.panel-3-header');
    
    if (panel2Header && panel3Header) {
      const panel2Height = panel2Header.offsetHeight;
      panel3Header.style.height = panel2Height + 'px';
      console.log('Panel 3 header height set to match Panel 2:', panel2Height + 'px');
    }
  }

  // Load mobile panel 2 content
  function loadMobilePanel2Content(parentHandle) {
    if (!mobilePanel2Content) return;
    
    const parent = menuData.find(item => item.handle === parentHandle);
    if (!parent || !parent.children) return;
    
    const html = parent.children.map(child => {
      if (child.children && child.children.length > 0) {
        // Has sub-children, show as button (full width)
        return `
          <button type="button" class="hamburger-menu-panel-item hamburger-menu-panel-item--has-children full-width-nav-link" 
                  data-menu-item="${child.handle}">
            <div class="hamburger-menu-panel-text">
              ${child.title}
              <svg class="hamburger-menu-arrow" viewBox="0 0 100 100">
                <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
              </svg>
            </div>
          </button>
        `;
      } else {
        // Direct link, show with image or full width
        if (child.isFullWidth) {
          // Full width link (no image)
          return `
            <a href="${child.url}" data-breadcrumbs="${currentParent}:${child.handle}" class="hamburger-menu-panel-item full-width-nav-link">
              <div class="hamburger-menu-panel-text">${child.title}</div>
            </a>
          `;
        } else {
          // Image link
          const imageStyle = child.image ? `style="background-image: url('${child.image}');"` : '';
          return `
            <a href="${child.url}" data-breadcrumbs="${currentParent}:${child.handle}" class="hamburger-menu-panel-item">
              <div class="hamburger-menu-panel-image" ${imageStyle}></div>
              <div class="hamburger-menu-panel-text">${child.title}</div>
            </a>
          `;
        }
      }
    }).join('');
    
    mobilePanel2Content.innerHTML = html;
    bindMenuClickEvents();
    
    // Add click handlers for mobile panel 2
    const buttons = mobilePanel2Content.querySelectorAll('.hamburger-menu-panel-item--has-children');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const menuItem = button.dataset.menuItem;
        const title = button.querySelector('.hamburger-menu-panel-text').textContent.trim();
        showMobilePanel3(title, menuItem);
      });
    });
  }

  // Load mobile panel 3 content
  function loadMobilePanel3Content(menuItem) {
    if (!mobilePanel3Content) return;
    
    const parent = menuData.find(item => item.handle === currentParent);
    if (!parent || !parent.children) return;
    
    const child = parent.children.find(c => c.handle === menuItem);
    if (!child || !child.children) return;
    
    const html = child.children.map(grandchild => {
      const imageStyle = grandchild.image ? `style="background-image: url('${grandchild.image}');"` : '';
      return `
        <a href="${grandchild.url}" data-breadcrumbs="${currentGrandParent}:${menuItem}:${grandchild.handle}" class="hamburger-menu-panel-item">
          <div class="hamburger-menu-panel-image" ${imageStyle}></div>
          <div class="hamburger-menu-panel-text">${grandchild.title}</div>
        </a>
      `;
    }).join('');
    
    mobilePanel3Content.innerHTML = html;
    bindMenuClickEvents();
  }



  // Open menu
  function openMenu() { 
    if (isOpen) {
       return;
    }

    Shopify.analytics.publish("navigation_open", {
      page_path: window.location.pathname,
      page_path_appended_query: window.location.pathname + window.location.search,
      page_url: window.location.href,
    });
     
    isOpen = true;
    if (hamburgerMenu) {
      hamburgerMenu.classList.add('is-open');
      hamburgerMenu.style.display = 'block'; 
      
      // Show panel 2 with promo images by default (if they exist)
      showPanel2WithPromoImages();
      
      // Also show mobile panel 2 with promo images by default
      showMobilePanel2WithPromoImages();
      
      // Only show panel 1 if no promo images (fallback)
      if (currentPanel === 1) {
        if (panel1) {
          panel1.classList.add('is-active'); 
        }
      }
      
      // Initialize mobile carousel after menu opens
      setTimeout(() => {
        initMobilePromoCarousel();
      }, 100);
    } else {
      console.error('Hamburger menu container not found!');
    }
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  // Close menu
  function closeMenu() {
    if (!isOpen) return;
    
    isOpen = false;
    if (hamburgerMenu) {
      hamburgerMenu.classList.remove('is-open');
      hamburgerMenu.style.display = 'none';
    }
    
    // Reset all panels
    resetPanels();
    
    // Allow body scroll
    document.body.style.overflow = '';
  }

  // Reset panel 3 (desktop)
  function resetPanel3() {
    if (currentPanel === 3) {
      currentPanel = 1;
      currentGrandParent = null;
      
      if (panel3) {
        panel3.classList.remove('is-active');
      }
      if (panel1) {
        panel1.classList.add('is-active');
      }
    }
  }

  // Handle mobile back button
  function handleMobileBack() {
    if (currentMobilePanel === 3) {
      // Go back from panel 3 to panel 2
      currentMobilePanel = 2;
      currentGrandParent = null;
      
      if (mobilePanel3) mobilePanel3.style.display = 'none';
      if (mobilePanel2) mobilePanel2.style.display = 'block';
    } else if (currentMobilePanel === 2) {
      // Go back from panel 2 to panel 1
      currentMobilePanel = 1;
      currentParent = null;
      
      if (mobilePanel2) mobilePanel2.style.display = 'none';
      if (mobilePanel1) mobilePanel1.style.display = 'block';
      
      // Hide all back buttons when back to panel 1
      if (mobileBackButtons && mobileBackButtons.length) {
        mobileBackButtons.forEach((btn) => (btn.style.display = 'none'));
      } else if (mobileBackButton) {
        mobileBackButton.style.display = 'none';
      }
    }
  }
  
  // Handle window resize for mobile carousel
  function handleResize() {
    // Debounce resize events
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(() => {
      if (window.innerWidth <= 768) {
        // On mobile, reinitialize carousel
        initMobilePromoCarousel();
      } else {
        // On desktop, destroy carousel if it exists
        const mobilePromoImages = document.getElementById('mobile-panel-1-promo-images');
        if (mobilePromoImages && mobilePromoImages.flickity) {
          mobilePromoImages.flickity.destroy();
        }
      }
    }, 250);
  }

  // Reset mobile panel 3
  function resetMobilePanel3() {
    if (currentMobilePanel === 3) {
      currentMobilePanel = 1;
      currentGrandParent = null;
      
      if (mobilePanel3) mobilePanel3.style.display = 'none';
      if (mobilePanel1) mobilePanel1.style.display = 'block';
      
      // Hide back button when resetting to panel 1
      if (mobileBackButton) {
        mobileBackButton.style.display = 'none';
      }
    }
  }



  // Reset all panels
  function resetPanels() {
    // Reset state
    currentPanel = 1;
    currentMobilePanel = 1;
    currentParent = null;
    currentGrandParent = null;
    
    // Reset desktop panels
    if (panel1) panel1.classList.remove('is-active');
    if (panel2) panel2.classList.remove('is-active');
    if (panel3) panel3.classList.remove('is-active');
    
    // Reset mobile panels
    if (mobilePanel1) mobilePanel1.style.display = 'block';
    if (mobilePanel2) mobilePanel2.style.display = 'none';
    if (mobilePanel3) mobilePanel3.style.display = 'none';
    
    // Hide mobile back buttons in panel headers
    const mobilePanel2BackButton = document.querySelector('#mobile-panel-2 .hamburger-menu-mobile-back');
    if (mobilePanel2BackButton) mobilePanel2BackButton.style.display = 'none';
    
    const mobilePanel3BackButton = document.querySelector('#mobile-panel-3 .hamburger-menu-mobile-back');
    if (mobilePanel3BackButton) mobilePanel3BackButton.style.display = 'none';
    
    // Clear navigation content from panel 2
    if (panel2Content) panel2Content.innerHTML = '';
    if (mobilePanel2Content) mobilePanel2Content.innerHTML = '';
    
    // Hide panel titles (will show again when navigation content is loaded)
    if (panel2Title) {
      panel2Title.textContent = '';
      panel2Title.style.display = 'none';
    }
    if (panel3Title) {
      panel3Title.textContent = '';
      panel3Title.style.display = 'none';
    }
    
    // Clear mobile panel titles
    const mobilePanel2Title = document.getElementById('mobile-panel-2-title');
    if (mobilePanel2Title) {
      mobilePanel2Title.textContent = '';
    }
    const mobilePanel3Title = document.getElementById('mobile-panel-3-title');
    if (mobilePanel3Title) {
      mobilePanel3Title.textContent = '';
    }
    
    // Remove navigation content styling
    const panelBody = document.querySelector('.hamburger-menu-panel-2 .hamburger-menu-panel-body');
    if (panelBody) panelBody.classList.remove('has-navigation-content');
    
    const mobilePanel = document.querySelector('#mobile-panel-2');
    if (mobilePanel) mobilePanel.classList.remove('has-navigation-content');
    
    // Show promo images for next menu open
    const promoImages = document.getElementById('panel-2-promo-images');
    if (promoImages) promoImages.style.display = 'block';
    
    const mobilePromoImages = document.getElementById('mobile-panel-1-promo-images');
    if (mobilePromoImages) mobilePromoImages.style.display = 'block';
  }

  // Reset desktop Panel 2 to initial promo state and clear navigation
  function resetPanel2ToPromoView() {
    // Clear header links
    const panel2HeaderLinks = document.getElementById('panel-2-header-links');
    if (panel2HeaderLinks) {
      panel2HeaderLinks.innerHTML = '';
    }

    // Clear grid content
    if (panel2Content) {
      panel2Content.innerHTML = '';
    }

    // Hide panel 2 title
    if (panel2Title) {
      panel2Title.textContent = '';
      panel2Title.style.display = 'none';
    }

    // Remove navigation padding class
    const panelBody = document.querySelector('.hamburger-menu-panel-2 .hamburger-menu-panel-body');
    if (panelBody) {
      panelBody.classList.remove('has-navigation-content');
      panelBody.scrollTop = 0;
    }

    // Show promo images container
    const promoImages = document.getElementById('panel-2-promo-images');
    if (promoImages) {
      promoImages.style.display = 'block';
    }

    // Activate panel 2 and deactivate panel 1
    currentPanel = 2;
    currentParent = null;
    if (panel1) panel1.classList.remove('is-active');
    if (panel2) {
      panel2.classList.add('is-active');
      panel2.classList.add('has-promo-image');
    }
  }

  // Handle keyboard events
  function handleKeydown(e) {
    if (!isOpen) return;
    
    if (e.key === 'Escape') {
      closeMenu();
    }
  }

  // Initialize when DOM is ready
  function startInit() {
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', init);
    } else {
       init();
    }
  }

  // Start initialization
   startInit();

})(); 